var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompas = function SvgCompas(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.438 14.43c3.833-2.175 9.984 3.241 14.667 1.997s7.818-.319 10.737 4.651c2.378 4.05-1.552 3.99 2.078 12.873s-2.563 9.454-8.548 9.454c-7.284.27-10.85.503-15.761.503-4.91 0-7.23.22-10.018-4.528-2.337-3.978-7.742-7.905-2.125-12.648 5.618-4.744 4.126-9.552 8.97-12.301Z",
    fill: "#FCF2F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 33.192c6.865 0 12.43-5.565 12.43-12.43 0-6.864-5.565-12.43-12.43-12.43-6.865 0-12.43 5.566-12.43 12.43 0 6.865 5.565 12.43 12.43 12.43Z",
    stroke: "#D84339",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 30.43c5.34 0 9.668-4.329 9.668-9.668A9.668 9.668 0 0 0 20 11.095c-5.34 0-9.668 4.328-9.668 9.667 0 5.34 4.329 9.668 9.668 9.668ZM20 8.332a2.762 2.762 0 1 0 0-5.524 2.762 2.762 0 0 0 0 5.524Z",
    stroke: "#D84339",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.095v2.071M20 28.358v2.072M29.667 20.762h-2.071M12.404 20.762h-2.072",
    stroke: "#D84339",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m21.464 22.226-6.837 3.908 3.909-6.836 6.83-3.908-3.902 6.836Z",
    stroke: "#D84339",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m18.536 19.298 2.928 2.928",
    stroke: "#D84339",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
};
export default SvgCompas;